"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocalStorage } from "@opensea/ui-kit/hooks";
import { useUnleashClient, useUnleashContext } from "@unleash/nextjs/client";
import { assign } from "es-toolkit/compat";
import { omit } from "es-toolkit/object";
import { isEqual } from "es-toolkit/predicate";
import { useEffect, useRef } from "react";
export function useFlagContext(t0) {
  const $ = _c(25);
  const {
    setReady
  } = t0;
  const updateUnleashContext = useUnleashContext();
  const unleashClient = useUnleashClient();
  const unleashClientStartedRef = useRef(false);
  const timeoutRef = useRef(null);
  let t1;
  if ($[0] !== unleashClient) {
    t1 = unleashClient.getContext().properties ?? {};
    $[0] = unleashClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [contextProperties, setContextProperties] = useLocalStorage("use-flag-context-properties", t1);
  let t2;
  if ($[2] !== unleashClient) {
    t2 = function getPreviousContext() {
      const currentContext = unleashClient.getContext();
      return omit(currentContext, ["appName", "environment"]);
    };
    $[2] = unleashClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getPreviousContext = t2;
  let t3;
  if ($[4] !== contextProperties || $[5] !== getPreviousContext || $[6] !== updateUnleashContext) {
    t3 = () => {
      updateUnleashContext({
        ...getPreviousContext(),
        properties: contextProperties
      });
    };
    $[4] = contextProperties;
    $[5] = getPreviousContext;
    $[6] = updateUnleashContext;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== contextProperties) {
    t4 = [contextProperties];
    $[8] = contextProperties;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
    t6 = [];
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] !== contextProperties || $[13] !== setContextProperties) {
    t7 = function updateContextProperties(updates) {
      const updated = assign(contextProperties, updates);
      if (isEqual(contextProperties, updated)) {
        return;
      }
      setContextProperties(updated);
    };
    $[12] = contextProperties;
    $[13] = setContextProperties;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const updateContextProperties = t7;
  let t8;
  if ($[15] !== setReady || $[16] !== unleashClient) {
    t8 = function startUnleashClient() {
      if (!unleashClientStartedRef.current) {
        unleashClient.start().then(() => {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            setReady(true);
            timeoutRef.current = null;
          }, 1000);
        });
        unleashClientStartedRef.current = true;
      }
    };
    $[15] = setReady;
    $[16] = unleashClient;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const startUnleashClient = t8;
  let t9;
  if ($[18] !== getPreviousContext || $[19] !== startUnleashClient || $[20] !== updateUnleashContext) {
    t9 = function setUserId(userId) {
      const previousContext = getPreviousContext();
      if (previousContext.userId !== userId) {
        updateUnleashContext({
          ...previousContext,
          userId
        }).then(startUnleashClient);
        return;
      }
      if (previousContext.userId === undefined) {
        startUnleashClient();
        return;
      }
    };
    $[18] = getPreviousContext;
    $[19] = startUnleashClient;
    $[20] = updateUnleashContext;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const setUserId = t9;
  let t10;
  if ($[22] !== setUserId || $[23] !== updateContextProperties) {
    t10 = {
      updateContextProperties,
      setUserId
    };
    $[22] = setUserId;
    $[23] = updateContextProperties;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}